import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Select, MenuItem } from "@mui/material";
import { callFunction } from "../../firebase";

const AdminUser = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function loadUsers() {
      try {
        setLoading(true);
        const response = await callFunction("admin/users", {}, "GET");
        if (!cancelled) setUsers(response?.users || []);
      } catch (e) {
        console.error("Failed to load users:", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    loadUsers();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        User Management
      </Typography>
      
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <CircularProgress size={20} />
                  </TableCell>
                </TableRow>
              ) : users.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No users found
                  </TableCell>
                </TableRow>
              ) : (
                users.map((u) => (
                  <TableRow key={u.id}>
                    <TableCell>{u.email}</TableCell>
                    <TableCell>
                      <Select
                        size="small"
                        value={u.role}
                        onChange={async (e) => {
                          const newRole = e.target.value;
                          try {
                            await callFunction(`admin/users/${u.id}/role`, { role: newRole }, "PUT");
                            setUsers((prev) => prev.map((x) => (x.id === u.id ? { ...x, role: newRole } : x)));
                          } catch (err) {
                            console.error("Failed to update role", err);
                          }
                        }}
                      >
                        <MenuItem value="admin">admin</MenuItem>
                        <MenuItem value="user">user</MenuItem>
                        <MenuItem value="banned">banned</MenuItem>
                      </Select>
                    </TableCell>
                    <TableCell>{u.disabled ? "Disabled" : "Active"}</TableCell>
                    <TableCell>{u.createdAt?.seconds ? new Date(u.createdAt.seconds * 1000).toLocaleString() : ""}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default AdminUser;
